<template>
    <div style="padding-top: 41px;" v-loading.fullscreen.lock="isLoading" element-loading-text="数据正在加载中" >
        <div id="topFix">
            <topNav></topNav>
        </div>
        <miniNav></miniNav>
        <Header></Header>
        <SubNav></SubNav>
        <div class="brandBg">
            <div class="pageWidth location"><a href="/" class="base lastLink">拍卖</a><strong>拍卖黄页</strong></div>
            <div class="filter">
                <h2>查找机构</h2>
                <FilterSearch :areaList="areaList" :cityList="cityList" :classList="classList" :letterList="letterList"></FilterSearch>
            </div>
            <BrandArea :brandArea="brandArea" :brandClass="brandClass"></BrandArea>
            <div class=" pageWidth mt10 oh  auctions ">
                <div class="lay300 fl mr20">
                    <h2 class="bdtit"><span class="titName">按分类搜索机构</span></h2>
                    <ul class="linkList bg" v-if="classList.length">
                        <li v-for="(item,i) in classList" :key="i"><a :href="`/mechanismsearch?area_name=&province=&class_name=${item.name}&letter=&name=`">{{item.name}}<span v-if="item.organ_count > 0">（{{ item.organ_count }}）</span></a></li>
                    </ul>
                    <!--图片广告-->
                    <div class="adv300x135 mt20">
                        <!-- <a href="//www.chieftown.com/" target="_blank">
                            <img width="300" height="135" alt="图片广告" src="">
                        
                        </a> -->
                        <AdvImage :advCode="'jdzdi1174'" ></AdvImage>
                    </div>
                </div>
                <div class="lay390 fl auctAgency">
                    <div class="bdtit">
                        <h2 class="titName">拍卖机构</h2>
                        <div class="city" :class="{'hover':orgFlag}" id="cityContain" @mouseenter="hoverOrg(true)" @mouseleave="hoverOrg(false)">
                            <div class="cityChoose">{{orgCity}}<b></b></div>
                            <div class="cityWrap" v-if="areaCity.length">
                                <dl v-for="(item,i) in areaCity" :key="i">
                                    <dt>{{item.areas_name}}</dt>
                                    <dd>
                                        <template v-for="(m,k) in item.city_name"><a href="javascript:;" :key="k" @click="getOrgList(m)">{{m}}</a></template>
                                    </dd>
                                </dl>
                            </div>
                        </div>
                    </div>
                    <div class="auctWrap" id="auctionWrap">
                        <ul class="recAuctList" v-if="orgList.length">
                            <li v-for="(item,i) in orgList" :key="i">
                                <a v-if="item.name=='中国嘉德'" target="_blank" :href='`https://www.cguardian.com`'>{{item.name}}</a>
                                <router-link v-else-if="item.organ_zone" target="_blank" :to='`/${item.organ_zone}`'>{{item.name}}</router-link>
                                <router-link v-else target="_blank" :to='`/org_detail/${item.organ_code}`'>{{item.name}}</router-link>
                                <!-- <a target="_blank" :href="'//auction.artron.net/'+item.organ_zone">{{item.name}}</a> -->
                            </li>
                        </ul>
                        <div class="allAuct">
                            <ul class="letterFilt" v-if="orgLetter.length">
                                <template v-for="(item,i) in orgLetter">
                                    <li :key="i" v-if="item.list == null" class="dis">{{item.letter}}</li>
                                    <li :key="i" v-else :class="{'curr':item.list ? idx[0] ==i : 0}" @click="jumpToCom(i,$event)">{{item.letter}}</li>
                                </template>
                            </ul>
                            <div class="allAuctShow">
                                <div class="allAuctList">
                                    <ul class="showList" v-for="(item,i) in orgLetter" :key="i">
                                        <li v-for="(con,k) in item.list" :key="k">
                                                    <template v-if="con.name=='中国嘉德'">
                                                <a :href='`https://www.cguardian.com`' target="_blank">{{con.name}}</a>
                                            </template>
                                            <router-link target="_blank" :to='`/${con.organ_zone}`' v-else-if="con.organ_zone">{{con.name}}</router-link>
                                            <router-link target="_blank" :to='`/org_detail/${con.organ_code}`' v-else>{{con.name}}</router-link>
                                            <!-- <a target="_blank" :href="'//auction.artron.net/'+con.organ_zone" v-if="con.organ_zone">{{con.name}}</a>
                                            <a :href="'//auction.artron.net /org_detail/'+con.organ_code" v-else>{{con.name}}</a> -->
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <ul class="auctSwitch">
                                <li class="dis"><a href="javascript:;" class="prev" @click="jumpArrw($event)"></a></li>
                                <li><a href="javascript:;" class="next" @click="jumpArrw($event)"></a></li>

                            </ul>
                        </div>

                    </div>
                </div>
                <div class="lay250 fr">
                    <h2 class="bdtit"><span class="titName">品牌故事</span></h2>
                    <div class="bg brandWrap">
                        <div class="brand">
                            <a :href="story.url" target="_blank"><img :src="story.pic" width="230" height="100" :alt="story.title"></a>
                            <h3 class="brandTitle"><a :href="story.url" target="_blank">{{story.title}}</a></h3>
                            <p class="subInfo">{{story.summary}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <Member :standList="standList" :zhongpaiList="zhongpaiList"></Member>
            <div class="pageWidth oh mt30 ranks">
                <div class="lay300 fl company">
                    <h2 class="bdtit"><span class="titName">拍卖公司成交额总排行</span></h2>
                    <div class="tabs bg">
                        <ul class="tabsTag oh rankTag">
                            <li class="curr">本季度</li>
                        </ul>
                        <div class="tabsCon" style="display: block;">
                            <table class="ol" v-if="rankCompany.length">
                                <thead>
                                <tr>
                                    <th class="order"></th>
                                    <th class="name">拍卖公司</th>
                                    <th class="num">拍卖场次</th>
                                    <th class="price">成交额(RMB,万元)</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr class="" v-for="(item,i) in rankCompany" :key="i">
                                    <td class="order"><span>{{i+1}}</span></td>
                                    <td class="name">
                                        <template v-if="item.company_name=='中国嘉德'">
                                                <a :href='`https://www.cguardian.com`' target="_blank">{{item.company_name}}</a>
                                            </template>
                                        <router-link v-else target="_blank" class="fBlodFW" :to='`/org_detail/${item.organ_code}`'>{{item.company_name}}</router-link>
<!--                                        <a class="fBlodFW" :href="item.pc_url" target="_blank">{{item.company_name}}</a>-->
                                        <!--img width="14" height="14" title="已开通官网" alt="已开通官网" src="../../assets/imgs/old/approve.png"--></td>
                                    <td class="num">{{item.auction_times}}</td>
                                    <td class="price">{{item.deal_price}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="lay660 fr works">
                    <h2 class="bdtit"><span class="titName">拍品成交价格总排行</span></h2>
                    <div class="tabs bg">
                        <ul class="tabsTag oh rankTag">
                            <li class="curr">本季度</li>
                        </ul>
                        <div class="tabsCon" style="display: block;">
                            <table class="ol" v-if="rankSingle.length">
                                <thead>
                                <tr>
                                    <th class="order"></th>
                                    <th class="name">拍品名称</th>
                                    <th class="comp">拍卖公司</th>
                                    <th class="price">成交额(RMB,元)</th>
                                    <th class="time">拍卖时间</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr class="" v-for="(item,i) in rankSingle" :key="i">
                                    <td class="order"><span>{{i+1}}</span></td>
                                    <td class="name">
                                        <router-link class="fBlodFW" :to="{path:'/paimai-'+item.artCode}" target="_blank">{{item.detail.workName}}</router-link>
                                    </td>
                                    <template v-for="(info,idx) in item.extraInfo">
                                        <td class="comp" v-if="info.label == '拍卖公司'" :key="idx"><span>{{info.text}}</span></td>
                                        <td class="price" v-if="info.label == '成交额'" :key="idx">
                                            <span>{{info.text}}</span>
                                        </td>
                                        <td class="time" v-if="info.label == '成交时间'" :key="idx"><span>{{info.text}}</span></td>
                                    </template>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Contact :coopList="coopList"></Contact>
        <Footer></Footer>
    </div>
</template>

<script>
import topNav from "@/components/oldCommon/topNav";
import miniNav from "@/components/oldCommon/miniNav";
import Header from "@/components/oldCommon/header";
import SubNav from "@/components/oldCommon/subNav";
import FilterSearch from "@/views/brand/components/filter";
import BrandArea from "@/views/brand/components/brandArea";
import Member from "@/views/brand/components/member";
import Contact from "@/views/brand/components/contact";
import Footer from "@/components/oldCommon/footer";
import {getBrand, getBrandMeta, getClass, getOrgList} from "@/api/brand";
import {getOther, getRank} from "@/api/index";
import AdvImage from '@/components/advert/advImage';
import $ from 'jquery'
import {
    mapActions,mapGetters
} from 'vuex';
import {getReco} from "@/api/product/detail";


export default {
    name: "index",
    data(){
        return{
            areaList:[],
            cityList:[],
            classList:[],
            letterList:[],
            brandClass:[],
            brandArea:[],
            orgCity:'北京',
            areaCity:[],
            orgFlag:false,
            orgList:[],
            orgLetter:[],
            standList:[],
            zhongpaiList:[],
            rankCompany:[],
            rankSingle:[],
            coopList:[],
            idx:[],
            isLoading:true,
            isLogin:0,
            story:{
                title:'',
                pic:'',
                summary:'',
                url:''
            }
        }
    },
    asyncData({ store }) {
        let params = {
            type:6,
        }
        return store.dispatch("pageBrand/getBrandIndex", [params, () => {}]);
    },
    computed:{
        ...mapGetters({
            getIsLoadIng: "pageBrand/getIsLoadIng",
            getData: "pageBrand/getData",
        }),
    },
    mounted() {
        this.getClass();
        this.getBrand();
        this.getOrgList();
        this.getRank();
        this.getOther();
        this.getStory();
        window.scroll({ top: 0, left: 0 })
        if (!this.getIsLoadIng){
            let parmas = {
                type:6
            }
            this.getBrandIndex([parmas,()=>{
                this.filteData();
            }])
        }else{
            this.filteData();
        }
        if(this.getCookie("_at_pt_0_")){
            this.isLogin = 1
        }
    },
    methods:{
        getCookie:function (name) {
            var arr;
            var reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
            if(document.cookie.match(reg)) {
                arr = document.cookie.match(reg);
                return arr[2];
            }else {
                return null;
            }
        },
        ...mapActions({
            getBrandIndex:"pageBrand/getBrandIndex"
        }),
        getStory(){
            let parmas = {
                cms_module_id:5
            }
            getReco(parmas).then((res) => {
                if(res.code == 0){
                    let brandJson = res.data.list[0]
                    this.story.title = brandJson.title
                    this.story.pic = brandJson.picture
                    this.story.summary = brandJson.summary
                    this.story.url = brandJson.url
                }
            })
        },
        filteData(){
            let data = this.$store.state["pageBrand"]["data"]
            console.log(data)
            let meta = data.meta;
            let head = document.getElementsByTagName('head');
            document.title = meta.title
            if(!document.querySelector('meta[name=description]')){
                let meta2 = document.createElement('meta');
                meta2.name = 'description';
                meta2.content = meta.description || '';
                head[0].appendChild(meta2)
            }else{
                document.querySelector('meta[name=description]').setAttribute('content',meta.description || '')
            }
        },
        getClass(){
            getClass().then((res) => {
                if(res.code == 0){
                    let dataJSON = res.data
                    this.areaList = dataJSON.area_list
                    this.cityList = dataJSON.city_list
                    this.classList = dataJSON.class_list
                    this.letterList = dataJSON.letter_list
                    this.isLoading = false
                }
            })
        },
        getBrand(){
            getBrand().then((res) => {
                if(res.code == 0){
                    let dataJSON = res.data
                    this.brandArea = dataJSON.perfect_area_list
                    this.brandClass = dataJSON.perfect_class_list
                    this.areaCity = dataJSON.area_city
                    this.standList = dataJSON.standard_list
                    this.zhongpaiList = dataJSON.zhongpai_list
                    for(let i in this.zhongpaiList){
                        this.$set(this.zhongpaiList[i], 'isOpen', false);
                    }
                }
            })
        },
        getOrgList(name){
            this.orgFlag = false
            this.orgCity = name ? name : '北京'
            let parmas = {
                city:this.orgCity
            }
            getOrgList(parmas).then((res) => {
                if(res.code == 0){
                    let data = res.data
                    let that = this
                    this.orgLetter = data.letter_organs
                    this.orgList = data.organs
                    that.idx = []
                    this.orgLetter.forEach(function (item,i){
                        if(item.list != null){
                            that.idx.push(i);
                        }
                    })
                }
            })
        },
        hoverOrg(flag){
            this.orgFlag = flag
        },
        getRank(){
            getRank().then((res) => {
                this.rankCompany= res.data.company
                this.rankSingle = res.data.single
            });
        },
        getOther(){
            getOther().then((res) => {
                let data = res.data;
                this.coopList = data.coop
            });
        },
        jumpToCom(num,e){
            let $target = $(e.target)
            let changeEle = $("#auctionWrap .allAuctList"),
                outerTop = changeEle.offset().top,
                outerHeight = parseFloat($("#auctionWrap .allAuctShow").css("height")),
                currTop = outerTop - changeEle.children(".showList:eq("+num+")").offset().top,
                currHeight = changeEle.children(".showList:eq("+num+")").outerHeight(),
                totalHeight = changeEle.outerHeight();
            $target.addClass('curr').siblings().removeClass('curr')
            $('.auctSwitch > li').removeClass('dis')
            if(currTop <= outerHeight - totalHeight){
                currTop = outerHeight - totalHeight;
                $(".auctSwitch > li:eq(1)").addClass("dis");
            }
            if(currTop >= 0){
                currTop = 0;
                $(".auctSwitch > li:eq(0)").addClass("dis");
            }
            $("#auctionWrap .allAuctList").stop().animate({
                "marginTop" : currTop + "px"
            }, 299);
        },
        jumpArrw(e){
            e.preventDefault();
            let $target = $(e.target)
            var changeEle = $("#auctionWrap .allAuctList"),
                initTop = parseFloat(changeEle.css("marginTop")) || 0,
                changeHeight = parseFloat($("#auctionWrap .allAuctShow").css("height")),
                totalHeight = changeEle.outerHeight(),endTop=0,
                outerTop = changeEle.offset().top;
            if(!$target.parent().hasClass("dis")){
                $target.parent().siblings().removeClass("dis");
                if($target.hasClass("prev")){
                    endTop = initTop + changeHeight;
                } else {
                    endTop = initTop - changeHeight;
                }
                if(endTop >= 0){
                    endTop = 0;
                    $target.parent().addClass("dis");
                } else if(endTop <= changeHeight - totalHeight){
                    endTop = changeHeight - totalHeight;
                    $target.parent().addClass("dis");
                }
                for(var i = 0, l = changeEle.children(".showList:visible").length; i < l; i++){
                    var currEle = changeEle.children(".showList:visible:eq("+i+")");
                    if(i >= l - 1){
                        var index = currEle.index();
                        $("#auctionWrap .letterFilt > li:eq("+index+")").addClass("curr").siblings(".curr").removeClass("curr");
                        break;
                    }
                    if(currEle.children().length > 0){
                        var currTop = outerTop - currEle.offset().top,
                            nextTop = outerTop - changeEle.children(".showList:visible:eq("+(i+1)+")").offset().top;
                        if(endTop > nextTop && endTop <= currTop){
                            var index = currEle.index();
                            $("#auctionWrap .letterFilt > li:eq("+index+")").addClass("curr").siblings(".curr").removeClass("curr");
                            break;
                        }
                    }
                }

                changeEle.stop().animate({
                    "marginTop" : endTop + "px"
                }, 299);
            }
        },
    },
    components:{
        topNav,
        miniNav,
        Header,
        SubNav,
        FilterSearch,
        BrandArea,
        Member,
        Contact,
        Footer,
        AdvImage
    }
}
</script>

<style lang="scss" scoped>
@import url('../../assets/css/resetOld.scss');
.auctAgency .bdtit{position: relative;}
.auctAgency .bdtit .titName{float:left;}

.linkList {
    padding: 13px 0px 15px 20px;
    overflow: hidden;
    _zoom: 1;
    height: 201px;
}
.linkList li {
    width: 140px;
    float: left;
    _display: inline;
    line-height: 24px;
    height: 24px;
    overflow: hidden;
}
.linkList li a {
    line-height: 1;
    font-size: 12px;
    padding: 2px 0px;
}
.linkList li span {
    color: #999999;
    font-family: Verdana;
}
.city {
    float: left;
}
.cityChoose {
    padding: 2px 10px 3px;
    cursor: pointer;
    font-size: 14px;
    float: left;
    font-family: 'Microsoft Yahei';
}
.cityWrap {
    display: none;
    position: absolute;
    top: 35px;
    left: 0px;
    width: 384px;
    height: 344px;
    background: #FFFFFF;
    border: 3px solid #0F820C;
    font-size: 12px;
    padding-top: 10px;
}
.cityChoose b {
    display: inline-block;
    font-size: 14px;
    _margin-top: 15px;
    vertical-align: middle;
    margin-left: 5px;
    background: url(../../assets/imgs/old/fold.png) 0px 0px no-repeat;
    width: 7px;
    height: 5px;
    cursor: pointer;
}
.auctAgency .bdtit .hover .cityChoose{background:#0F820C; color:#FEFEFE;}
.auctAgency .bdtit .hover b{background-position:0px -10px;}
.cityWrap dl {
    padding: 10px 0px;
}
.cityWrap dt {
    float: left;
    _display: inline;
    font-weight: bold;
    width: 74px;
    padding-right: 20px;
    text-align: right;
    color: #999999;
    line-height: 14px;
    height: 14px;
    overflow: hidden;
    border-right: 1px solid #dcdcdc;
}
.cityWrap dd {
    margin-left: 95px;
    line-height: 1;
}
.cityWrap a, .cityWrap span {
    margin-left: 20px;
}
.auctAgency .hover .cityWrap{ display:block;}
.recAuctList {
    background: url(../../assets/imgs/old/dashed.png) 0px 100% repeat-x;
    padding: 9px 0px 12px;
    height: 149px;
    width:390px;
}
.recAuctList li, .allAuctShow li {
    float: left;
    _display: inline;
    width: 94px;
    height: 32px;
    overflow: hidden;
    font: 14px/32px Arial, 'Microsoft Yahei';
    word-break: break-all;
}
.letterFilt {
    overflow: hidden;
    padding-top: 20px;
    width: 395px;
    margin-left: -5px;
}
.letterFilt li {
    float: left;
    _display: inline;
    padding: 0px 10px;
    margin-right: 5px;
    background: url(../../assets/imgs/old/bg.png) 0px 0px repeat;
    font: 14px/22px Verdana;
    color: #666666;
    cursor: pointer;
}
.letterFilt li.dis{
    color: #999999;
    cursor: default;
}
.letterFilt .curr {
    background: #000;
    color: #FEFEFE;
}
.recAuctList li {
    font-weight: bold;
}
.allAuctShow {
    margin: 9px 0px 12px;
    height: 128px;
    overflow: hidden;
}
.recAuctList, .allAuctShow ul {
    overflow: hidden;
    _zoom: 1;
    padding-left: 10px;
}
.auctSwitch li {
    float: left;
    _display: inline;
    width: 195px;
    height: 16px;
    overflow: hidden;
}

element.style {
}
.auctSwitch .prev {
    background-position: 0 0;
}
.auctSwitch a {
    display: block;
    width: 195px;
    height: 16px;
    background-image: url(../../assets/imgs/old/arrow_btn.png);
    background-repeat: no-repeat;
}
.auctSwitch .prev{background-position: 0 0;}
.auctSwitch .next:hover{background-position: -196px -21px;}
.auctSwitch a:hover{
    background-color: #0f820c;
}
.auctSwitch .next {
    background-position: -196px 0;
}
.auctSwitch .next{background-position: -196px 0;}

.auctSwitch .prev {
    background-position: 0 0;
}
.auctSwitch .prev:hover{background-position: 0 -21px;}
.auctSwitch .dis .prev,.auctSwitch .dis .prev:hover{background-position: 0 -42px; cursor: default;}
.auctSwitch .dis .next,.auctSwitch .dis .next:hover{background-position: -196px -42px;cursor: default;}
.brandWrap {
    padding: 10px;
}
.brandWrap .brand {
    background: #FFFFFF;
    font-size: 12px;
    line-height: 24px;
    height: 338px;
    overflow: hidden;
}
.brandWrap h3 {
    font-size: 12px;
    padding: 14px 10px 0px;
    height: 24px;
    overflow: hidden;
}
.brand .subInfo {
    color: #666666;
    padding: 0px 10px;
    height: 195px;
    overflow: hidden;
}

/*排行*/
.ranks .tabs {
    padding: 10px;
}
.ranks .tabsTag {
    overflow: hidden;
    _zoom: 1;
    border-bottom: 1px solid #000;
}
.ranks .tabsTag li {
    float: left;
    _display: inline;
    margin-right: 1px;
    font: bold 12px/24px '宋体';
    height: 24px;
    padding: 0 10px;
    cursor: pointer;
}
.ranks .tabsTag .curr {
    background: #000000;
    color: #FEFEFE;
}
.ol {
    width: 100%;
    padding: 0px;
    table-layout: fixed;
}
.ol .order {
    width: 30px;
}
.ol th, .ol td {
    font: 12px/30px '宋体';
    background: #FFFFFF;
    height: 30px;
    overflow: hidden;
}
.ol th {
    height: 22px;
    line-height: 22px;
    padding-top: 5px!important;
    color: #999999;
}
.ol .order span {
    display: inline-block;
    vertical-align: middle;
    width: 20px;
    height: 20px;
    background: #000;
    line-height: 20px;
    color: #FEFEFE;
    font-family: Verdana;
    text-align: center;
}
.company .name {
    width: 80px;
}
.company .num {
    width: 48px;
}
.company .price {
    font-family: Verdana;
    text-align: right;
    width: 110px;
}
.works .name {
    width: 260px;
    text-align: left;
    line-height: 0;
}
.works .name a{display:inline-block;max-width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;font-size: 12px;line-height: 30px;}
.works .comp {
    width: 100px;
    text-align: left;
}
.works .price {
    font-family: Verdana;
    text-align: right;
    width: 120px;
}
.works .time {
    font-family: Verdana;
    text-align: left;
    width: 90px;
    padding-left: 20px;
}
.filter {
    padding: 0px 10px 10px;
    width: 980px;
    margin: 0 auto;
    background: #0F820C;
    margin-top: 10px;
}
.filter h2 {
    font: bold 14px/30px 'Microsoft Yahei';
    padding-bottom: 2px;
    color: #FEFEFE;
}
.brand {
    .brandTitle {
        height: 38px;
    }
}
</style>